<template>
  <div>
    <div class="flex-between">
      <div class="title">添加任务</div>
      <el-button style="height: 100%" size="small" @click="goBack"
        >返回列表</el-button
      >
    </div>
    <div class="task-container">
      <el-form
        label-width="120px"
        :model="taskInfo"
        :rules="taskRules"
        ref="taskInfo"
      >
        <el-form-item label="任务名称：" prop="title" :show-message="false">
          <el-input
            class="w-400"
            v-model="taskInfo.title"
            size="small"
            placeholder="请输入任务名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务说明："
          prop="description"
          :show-message="false"
        >
          <el-input
            class="w-400"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5 }"
            v-model="taskInfo.description"
            size="small"
            placeholder="请输入任务说明"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="计划结束时间："
          prop="plan_time"
          :show-message="false"
        >
          <el-date-picker
            v-model="taskInfo.plan_time"
            size="small"
            type="datetime"
            placeholder="请选择计划结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="完成按钮：" prop="btn_text" :show-message="false">
          <el-input
            class="w-400"
            v-model="taskInfo.btn_text"
            size="small"
            placeholder="请输入完成按钮的文字"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="反馈控件：">
          <el-switch v-model="taskInfo.feedback"></el-switch>
        </el-form-item>
        <el-form-item label="类型：" prop="type" :show-message="false">
          <el-select
            class="w-150"
            v-model="taskInfo.type"
            size="small"
            placeholder="请选择类型"
            clearable
          >
            <el-option label="MarkDown" value="markdown"></el-option>
            <!-- <el-option label="学员目标制定" value="objective"></el-option> -->
            <el-option label="课程" value="course"></el-option>
            <el-option label="项目" value="project"></el-option>
          </el-select>
        </el-form-item>

        <template v-if="taskInfo.type === 'markdown'">
          <Markdown
            :value.sync="taskInfo.md"
            defaultOpen="edit"
            space="_for_kungfu_sub_project"
            folder="fuwu"
          ></Markdown>
        </template>

        <template v-if="taskInfo.type === 'objective'">
          <el-form-item label="内容：">
            <el-input
              class="w-400"
              v-model="taskInfo.objective"
              size="small"
              placeholder="我的目标是......"
              clearable
            ></el-input>
            <el-select
              style="margin-left: 12px"
              v-model="taskInfo.timeSpent"
              size="small"
              placeholder="为此我愿意花......"
              clearable
            >
              <el-option label="一周" :value="1"></el-option>
              <el-option label="一个月" :value="2"></el-option>
              <el-option label="三个月" :value="3"></el-option>
              <el-option label="半年" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </template>

        <template v-if="taskInfo.type === 'course'">
          <el-button type="primary" size="mini" @click="getCourse"
            >选择课程</el-button
          >
          <el-table :data="taskInfo.course" class="mt-12">
            <el-table-column label="课程名称" prop="name"></el-table-column>
            <el-table-column label="分类">
              <template slot-scope="scope">
                <el-tag
                  type="info"
                  style="margin-right: 8px"
                  v-for="item in scope.row.categories"
                  :key="item.id"
                  size="mini"
                >
                  {{ item.name }} => {{ item.parent.name }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              width="55"
              label="难度"
              prop="difficulty_level_label"
            ></el-table-column>
            <el-table-column
              width="80"
              label="时长"
              prop="total_duration"
            ></el-table-column>
            <el-table-column width="80" label="课时数">
              <template slot-scope="scope">
                {{ scope.row.lessons_count }} 课时
              </template>
            </el-table-column>
            <el-table-column width="55" label="预览">
              <template slot-scope="scope">
                <div style="text-align: center">
                  <el-link
                    type="primary"
                    :underline="false"
                    icon="el-icon-view"
                    @click="goCourseDetail(scope.row.id)"
                  ></el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>

        <div v-if="taskInfo.type === 'project'">
          <el-button type="primary" size="mini" @click="getProject"
            >选择项目</el-button
          >
          <el-table border :data="taskInfo.project" class="mt-12">
            <el-table-column label="项目名称" prop="name"></el-table-column>
            <el-table-column
              width="150"
              label="职业方向"
              prop="job_name"
            ></el-table-column>
            <el-table-column width="55" label="难度">
              <template slot-scope="scope">
                <span v-if="scope.row.difficult_level === null">暂无</span>
                <span v-if="scope.row.difficult_level === 1">入门</span>
                <span v-if="scope.row.difficult_level === 2">初阶</span>
                <span v-if="scope.row.difficult_level === 3">进阶</span>
                <span v-if="scope.row.difficult_level === 4">高阶</span>
              </template>
            </el-table-column>
            <el-table-column
              width="60"
              label="时长"
              prop="duration"
            ></el-table-column>
            <el-table-column label="教学目标">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">
                    <pre>{{ scope.row.teaching_aim }}</pre>
                  </div>
                  <span class="hidden-redundant">{{
                    scope.row.teaching_aim
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="技能点">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">
                    <pre>{{ scope.row.skill }}</pre>
                  </div>
                  <span class="hidden-redundant">{{ scope.row.skill }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="55" label="详情">
              <template slot-scope="scope">
                <div style="text-align: center">
                  <el-link
                    type="primary"
                    :underline="false"
                    icon="el-icon-view"
                    @click="goProjectDetail(scope.row.id)"
                  ></el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <div class="submit-btn">
        <zhu-button
          text="提交"
          :shadow="true"
          type="primary"
          :loading="btnLoading"
          @click="addTask"
        ></zhu-button>
      </div>
    </div>

    <el-dialog
      title="课程选择"
      :visible.sync="courseVisible"
      width="1200px"
      :append-to-body="true"
    >
      <div class="dialog-body">
        <div class="search-box">
          <el-cascader
            ref="cascader"
            class="search-cascader"
            placeholder="课程分类"
            v-model="courseSearch.category_id"
            size="mini"
            :options="categories"
            :props="categoriesProps"
            :show-all-levels="false"
            clearable
          >
            <template slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
              <span v-if="!node.isLeaf"> ({{ data.contents.length }}) </span>
            </template>
          </el-cascader>
          <el-select
            class="search-select"
            size="mini"
            placeholder="请选择难度"
            v-model="courseSearch.difficulty_level"
          >
            <el-option label="入门" :value="1"></el-option>
            <el-option label="初阶" :value="2"></el-option>
            <el-option label="进阶" :value="3"></el-option>
            <el-option label="高阶" :value="4"></el-option>
          </el-select>
          <el-input
            class="search-input"
            placeholder="课程名称"
            prefix-icon="el-icon-search"
            v-model="courseSearch.name"
            size="mini"
            clearable
          >
          </el-input>
          <el-button type="primary" size="mini" plain @click="searchCourse"
            >查询</el-button
          >
          <el-button size="mini" @click="clearSearchCourse">重置</el-button>
        </div>
        <el-table
          border
          :data="courseList"
          :stripe="true"
          v-loading="tableLoading"
          highlight-current-row
          @current-change="courseCurrentChange"
        >
          <el-table-column label="课程名称" prop="name"></el-table-column>
          <el-table-column label="分类">
            <template slot-scope="scope">
              <el-tag
                type="info"
                style="margin-right: 8px"
                v-for="item in scope.row.categories"
                :key="item.id"
                size="mini"
              >
                {{ item.name }} => {{ item.parent.name }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            width="55"
            label="难度"
            prop="difficulty_level_label"
          ></el-table-column>
          <el-table-column
            width="80"
            label="时长"
            prop="total_duration"
          ></el-table-column>
          <el-table-column width="80" label="课时数">
            <template slot-scope="scope">
              {{ scope.row.lessons_count }} 课时
            </template>
          </el-table-column>
          <el-table-column width="55" label="预览">
            <template slot-scope="scope">
              <div style="text-align: center">
                <el-link
                  type="primary"
                  :underline="false"
                  icon="el-icon-view"
                  @click="goCourseDetail(scope.row.id)"
                ></el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          @current-change="getCourse"
          :current-page.sync="coursePagination.currentPage"
          :page-size="coursePagination.pageSize"
          :total="coursePagination.total"
          :hide-on-single-page="true"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="selectCourse"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="项目选择"
      :visible.sync="projectVisible"
      width="1200px"
      :append-to-body="true"
    >
      <div class="dialog-body">
        <div class="search-box">
          <el-select
            class="search-select"
            v-model="projectSearch.job_id"
            size="mini"
            placeholder="请选择职业"
          >
            <el-option
              v-for="item in jobs"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            class="search-select"
            v-model="projectSearch.difficult_level"
            size="mini"
            placeholder="请选择难度"
          >
            <el-option label="入门" :value="1"></el-option>
            <el-option label="初阶" :value="2"></el-option>
            <el-option label="进阶" :value="3"></el-option>
            <el-option label="高阶" :value="4"></el-option>
          </el-select>
          <el-input
            class="search-input"
            v-model="projectSearch.name"
            size="mini"
            prefix-icon="el-icon-search"
            placeholder="项目名称"
            clearable
          >
          </el-input>
          <el-button
            class="search-btn"
            type="primary"
            size="mini"
            plain
            @click="searchProject"
            >查询</el-button
          >
          <el-button size="mini" @click="clearSearchProject">重置</el-button>
        </div>
        <el-table
          border
          :data="projectList"
          :stripe="true"
          v-loading="tableLoading"
          highlight-current-row
          @current-change="projectCurrentChange"
        >
          <el-table-column label="项目名称" prop="name"></el-table-column>
          <el-table-column
            width="150"
            label="职业方向"
            prop="job_name"
          ></el-table-column>
          <el-table-column width="55" label="难度">
            <template slot-scope="scope">
              <span v-if="scope.row.difficult_level === null">暂无</span>
              <span v-if="scope.row.difficult_level === 1">入门</span>
              <span v-if="scope.row.difficult_level === 2">初阶</span>
              <span v-if="scope.row.difficult_level === 3">进阶</span>
              <span v-if="scope.row.difficult_level === 4">高阶</span>
            </template>
          </el-table-column>
          <el-table-column
            width="60"
            label="时长"
            prop="duration"
          ></el-table-column>
          <el-table-column label="教学目标">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">
                  <pre>{{ scope.row.teaching_aim }}</pre>
                </div>
                <span class="hidden-redundant">{{
                  scope.row.teaching_aim
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="技能点">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">
                  <pre>{{ scope.row.skill }}</pre>
                </div>
                <span class="hidden-redundant">{{ scope.row.skill }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="55" label="详情">
            <template slot-scope="scope">
              <div style="text-align: center">
                <el-link
                  type="primary"
                  :underline="false"
                  icon="el-icon-view"
                  @click="goProjectDetail(scope.row.id)"
                ></el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          @current-change="getProject"
          :current-page.sync="projectPagination.currentPage"
          :page-size="projectPagination.pageSize"
          :total="projectPagination.total"
          :hide-on-single-page="true"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="selectProject"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Markdown from "@/components/Markdown";
import studentService from "@/global/service/student";

export default {
  components: {
    Markdown
  },
  data() {
    return {
      tableLoading: false,
      btnLoading: false,
      taskInfo: {
        title: "",
        description: "",
        plan_time: null,
        btn_text: "",
        feedback: false,
        type: null,
        md: "",
        objective: "",
        timeSpent: null,
        course: [],
        project: []
      },
      taskRules: {
        title: { required: true, trigger: "blur" },
        description: { required: true, trigger: "blur" },
        plan_time: { required: true, trigger: "blur" },
        btn_text: { required: true, trigger: "blur" },
        type: { required: true, trigger: "blur" }
      },
      categories: [],
      jobs: [],
      courseVisible: false,
      courseSearch: {
        category_id: null,
        difficulty_level: null,
        name: null
      },
      courseList: [],
      courseSelect: {},
      coursePagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      categoriesProps: {
        expandTrigger: "hover",
        emitPath: false,
        value: "id",
        label: "name",
        children: "contents"
      },
      projectVisible: false,
      projectSearch: {
        job_id: null,
        difficult_level: null,
        name: null
      },
      projectList: [],
      projectSelect: {},
      projectPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      Promise.all([
        studentService.courseCategories(),
        studentService.projectJobs()
      ]).then(([categories, jobs]) => {
        this.categories = categories.map(data => {
          data.contents.forEach(item => {
            item.contents = null;
          });
          return data;
        });
        this.jobs = jobs;
      });
    },
    goBack() {
      const id = this.$route.params.id;
      this.$router.push({ name: "StudentDetail", params: { id } });
    },
    addTask() {
      this.$refs["taskInfo"].validate(val => {
        if (!val) {
          this.$message.error("缺少必要参数");
          return;
        }
        const id = this.$route.params.id;
        const content = {
          md: this.taskInfo.md,
          objective: this.taskInfo.objective,
          timeSpent: this.taskInfo.timeSpent
        };
        const params = {
          name: this.taskInfo.title,
          description: this.taskInfo.description,
          plan_end_at: this.taskInfo.plan_time,
          finished_button_text: this.taskInfo.btn_text,
          need_student_feedback: this.taskInfo.feedback,
          source_type: this.taskInfo.type,
          content
        };
        let noLength = false;
        if (this.taskInfo.type === "course") {
          if (this.taskInfo.course.length === 0) {
            this.$message.error("请选择一门课程");
            noLength = true;
            return;
          }
          params.source_id = this.taskInfo.course[0].id;
        } else if (this.taskInfo.type === "project") {
          if (this.taskInfo.project.length === 0) {
            this.$message.error("请选择一个项目");
            noLength = true;
            return;
          }
          params.source_id = this.taskInfo.project[0].id;
        }
        if (noLength) return;
        this.btnLoading = true;
        studentService
          .taskAdd(id, params)
          .then(() => {
            this.$message.success("添加成功");
            this.$router.push({
              name: "StudentDetail",
              params: { id }
            });
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    getCourse() {
      let category_level = this.courseSearch.category_id ? 2 : null;
      const params = {
        page: this.coursePagination.currentPage,
        page_size: this.coursePagination.pageSize,
        category_level,
        category_id: this.courseSearch.category_id,
        difficulty_level: this.courseSearch.difficulty_level,
        name: this.courseSearch.name
      };
      this.tableLoading = true;
      this.courseVisible = true;
      studentService
        .courseList(params)
        .then(res => {
          this.courseList = res.list;
          this.coursePagination.currentPage = Number(
            res.pagination.current_page
          );
          this.coursePagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    getProject() {
      const params = {
        page: this.projectPagination.currentPage,
        page_size: this.projectPagination.pageSize,
        job_id: this.projectSearch.job_id,
        difficult_level: this.projectSearch.difficult_level,
        name: this.projectSearch.name
      };
      this.tableLoading = true;
      this.projectVisible = true;
      studentService
        .projectList(params)
        .then(res => {
          this.projectList = res.list;
          this.projectPagination.currentPage = Number(
            res.pagination.current_page
          );
          this.projectPagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    searchCourse() {
      this.coursePagination.currentPage = 1;
      this.getCourse();
    },
    searchProject() {
      this.projectPagination.currentPage = 1;
      this.getProject();
    },
    clearSearchCourse() {
      this.coursePagination.currentPage = 1;
      this.courseSearch.category_id = null;
      this.courseSearch.difficulty_level = null;
      this.courseSearch.name = null;
      this.getCourse();
    },
    clearSearchProject() {
      this.projectPagination.currentPage = 1;
      this.projectSearch.job_id = null;
      this.projectSearch.difficult_level = null;
      this.projectSearch.name = null;
      this.getProject();
    },
    goCourseDetail(id) {
      window.open(`//www${process.env.VUE_APP_DOMAIN}/course/${id}`);
    },
    goProjectDetail(id) {
      const PREFIX = window.location.origin;
      window.open(PREFIX + "/other/project/" + id);
    },
    courseCurrentChange(val) {
      this.courseSelect = val;
    },
    projectCurrentChange(val) {
      this.projectSelect = val;
    },
    selectCourse() {
      this.$set(this.taskInfo.course, 0, this.courseSelect);
      this.courseVisible = false;
    },
    selectProject() {
      this.$set(this.taskInfo.project, 0, this.projectSelect);
      this.projectVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.hidden-redundant {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.task-container {
  margin: 30px auto 0;
  width: 750px;
}
.submit-btn {
  margin: 36px 0 24px;
  text-align: center;
  .el-button {
    width: 750px;
  }
}
.dialog-body {
  padding: 0 48px;
  .search-box {
    display: flex;
    margin-bottom: 12px;
    .search-input {
      margin-right: 12px;
      width: 170px;
    }
    .search-select {
      margin-right: 12px;
      width: 120px;
    }
    .search-cascader {
      margin-right: 12px;
      width: 140px;
    }
  }
}
</style>
